<!--
 * @Author: zxf
 * @Date: 2022-07-26 22:24:00
 * @LastEditors: zxf
 * @LastEditTime: 2023-06-30 18:04:41
 * @Description: 同步操作员至省平台
-->
<template>
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-80 o-dialog--lg-60 o-dialog--xl-50"
    title="上传结果查看"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <div class="block">
      <section>
        <el-form
          ref="fd"
          class="c-form"
          :model="fd"
          :inline="true"
          label-position="right"
          label-width="100px"
          label-suffix="："
        >
          <el-row
            class="c-form__row"
          >
            <el-col
              class="c-form__col"
              :span="24"
            >
              <el-form-item
                class="c-form__item"
                label="项目名称"
                prop="xmmc"
              >
                <span
                  class="c-form__read"
                >
                  {{ fd.xmmc }}
                </span>
              </el-form-item>
            </el-col>

            <el-col
              class="c-form__col"
              :span="16"
            >
              <el-form-item
                class="c-form__item"
                label="报告编号"
                prop="bgbh"
              >
                <span
                  class="c-form__read"
                >
                  {{ fd.bgbh }}
                </span>
              </el-form-item>
            </el-col>

            <el-col
              class="c-form__col"
              :span="8"
            >
              <el-form-item
                class="c-form__item"
                label="执行结果"
                prop="zxjg"
              >
                <span
                  class="c-form__read"
                  :class="(dlParams.flag === undefined && fd.gdshTsbz === 'Y') || dlParams.flag ? 'u-text-success': 'u-text-danger'"
                >
                  {{ (dlParams.flag === undefined && fd.gdshTsbz === 'Y') || dlParams.flag ? '成功' : '失败' }}

                </span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </section>
      <div style="margin-top: 20px;">
        <el-timeline class="dev-o-wbbg__result">
          <el-timeline-item
            v-for="(step, idx) in steps"
            :key="idx"
            :type="result[step.status] ==='Y' ? 'success' : 'danger'"
            :icon="result[step.status] ==='Y' ? 'el-icon-check' : 'el-icon-close'"
            timestamp="2018/4/12"
            :hide-timestamp="true"
            size="large"
            placement="top"
          >
            <el-card>
              <h4>
                {{ step.stepName }}
                <span
                  class="dev-o-wbbg__comment"
                  :class="{
                    'u-text-success': result[step.status] ==='Y',
                    'u-text-danger': result[step.status] !=='Y' && result[step.failNum] > 0,
                    'u-text-info': result[step.status] !=='Y' && result[step.failNum] < 1}"
                >
                  （{{ result[step.status] === 'Y' ? '上传成功' : (result[step.status] !=='Y' && result[step.failNum] > 0 ? '上传失败' : '无上传记录') }}）
                </span>
              </h4>
              <ul
                v-if="result[step.flag] && step.listField && step.listField.length > 0"
                class="dev-o-wbbg__list"
              >
                <li
                  v-for="(_li, _lidx) in step.listField"
                  :key="_lidx"
                >
                  <span class="dev-o-wbbg__list-name">{{ _li.name }}</span>
                  <span
                    :class="{
                      'u-text-success': result[step.status] ==='Y',
                      'u-text-danger': result[step.status] !=='Y' && result[step.failNum] > 0,
                      'u-text-info': result[step.status] !=='Y' && result[step.failNum] < 1}"
                  >
                    <i
                      v-if="result[step.status] === 'Y'"
                      class="el-icon-check"
                    />
                    <i
                      v-else-if="result[step.failNum] > 0"
                      class="el-icon-close"
                    />
                    <span
                      v-else
                      class="u-text-info"
                    >无上传记录</span>

                  </span>
                  <div>
                    <upload-step-result
                      :step="_li"
                      :result="result"
                      @callback="handleLinkFunction"
                    />
                  </div>
                </li>
              </ul>
              <div v-else>
                <upload-step-result
                  :step="step"
                  :result="result"
                  @callback="handleLinkFunction"
                />
              </div>
            </el-card>
          </el-timeline-item>
        </el-timeline>
      </div>
    </div>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <el-button
        @click="closeDialog()"
      >
        关闭
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { pgsjtsService } from './pgsjts.service';
import UploadStepResult from '@/features/upload/gdUploadStepResult.vue';

export default {
  name: 'GdPgResultDialog',
  components: {
    UploadStepResult
  },
  props: {
    dlParams: {
      type: Object,
      default: function () {
        return {};
      }
    },
    bgInfo: {
      type: Array,
      default: function () {
        return [];
      }
    }
  },
  data () {
    return {
      loading: false, // 页面loading建筑类别
      dialogShow: true, // 模态框dialog显示
      result: {},
      fd: {},
      steps: [{
        stepName: '评估项目信息',
        status: 'base',
        tplType: 'info',
        successNum: 'baseSNum',
        failNum: 'baseFNum',
        stepResults: 'baseMsg',
        flag: 'baseMsgFlag',
        defineField: [{
          name: '委托单位 ',
          type: 'link',
          value: 'WTDW',
          key: 'XM',
          id: 'fldGuid'
        }, {
          name: '评估日期',
          type: 'text',
          value: 'PGTime'
        }]
      }, {
        stepName: '建筑信息',
        status: 'jzw',
        tplType: 'table',
        failNum: 'jzwFNum',
        stepResults: 'jzwMsg',
        flag: 'jzwMsgFlag',
        defineField: [{
          name: '建筑地址',
          type: 'link',
          value: 'JZMC',
          key: 'JZW',
          id: 'fldXMGuid'
        }
        ]
      }, {
        stepName: '项目签到信息',
        tplType: 'table',
        status: 'qd',
        successNum: 'qdSNum',
        failNum: 'qdFNum',
        stepResults: 'qdMsg',
        flag: 'qdMsgFlag',
        defineField: [{
          name: '签到人',
          type: 'text',
          value: 'CZYXM'
        }, {
          name: '签到地址',
          type: 'text',
          value: 'fldGPSDZ'
        }, {
          name: '签到时间',
          type: 'text',
          value: 'fldSignInDate'
        }]
      }, {
        stepName: '评估问题信息',
        tplType: 'table',
        status: 'wt',
        successNum: 'wtSNum',
        failNum: 'wtFNum',
        stepResults: 'wtMsg',
        flag: 'wtMsgFlag',
        defineField: [{
          name: '问题详情',
          type: 'text',
          value: 'fldContent'
        }]
      }, {
        stepName: '评估报告信息',
        tplType: 'info',
        status: 'bg',
        successNum: 'bgSNum',
        failNum: 'bgFNum',
        stepResults: 'bgMsg',
        flag: 'bgMsgFlag',
        defineField: [{
          name: '报告编号',
          type: 'link',
          value: 'XMBGGH',
          id: 'fileId',
          key: 'BG',
          loading: true
        }
        ]
      }
      ]
    };
  },
  computed: {
  },
  methods: {
    /**
     * @description: 处理链接方法
     * @return {*}
     * @param {*} e
     * @param {*} key
     * @param {*} _value
     * @param {*} _id
     */
    handleLinkFunction (e, _params) {
      const _this = this;
      const key = _params.key;
      const _value = _params.value;
      const _id = _params.id;
      if (key === 'XM') {
        _this.openNavTab({ name: 'pgxmDetail', params: { xmId: _value[_id], showType: 'xmInfo' } });
      } else if (key === 'BG') {
        _this.$utils.previewPdf(e, _value[_id], _value);
      } else if (key === 'JZW') {
        _this.openNavTab({ name: 'pgxmDetail', params: { xmId: _value[_id], showType: 'action' } });
      }
    },

    getPgbgUploadResult () {
      const _this = this;
      _this.loading = true;
      pgsjtsService.getGdshptResult(_this.dlParams.bgId)
        .then(rsp => {
          if (rsp.data !== '' && rsp.data !== undefined) {
            _this.result = rsp.data;

            _this.result.bgId = _this.dlParams.bgId;
            _this.result.baseFlag = _this.result.baseMsg && _this.result.baseMsg.length > 0;
            if (_this.result.baseFlag) {
              _this.result.baseMsg.forEach(e => {
                e.params = JSON.parse(e.params);
              });
            }

            _this.result.jzwMsgFlag = _this.result.jzwMsg && _this.result.jzwMsg.length > 0;
            if (_this.result.jzwMsgFlag) {
              _this.result.jzwMsg.forEach(e => {
                e.params = JSON.parse(e.params);
              });
            }
            _this.result.qdMsgFlag = _this.result.qdMsg && _this.result.qdMsg.length > 0;
            if (_this.result.qdMsgFlag) {
              _this.result.qdMsg.forEach(e => {
                e.params = JSON.parse(e.params);
              });
            }
            _this.result.wtMsgFlag = _this.result.wtMsg && _this.result.wtMsg.length > 0;
            if (_this.result.wtMsgFlag) {
              _this.result.wtMsg.forEach(e => {
                e.params = JSON.parse(e.params);
              });
            }
            _this.result.bgMsgFlag = _this.result.bgMsg && _this.result.bgMsg.length > 0;
            if (_this.result.bgMsgFlag) {
              _this.result.bgMsg.forEach(e => {
                e.params = JSON.parse(e.params);
              });
            }
          }
        })
        .catch(err => {
          console.error('获取维保报告上传结果信息失败', err);
        })
        .finally(() => {
          _this.loading = false;
        });
    },

    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    }
  },
  created () {
    this.fd = this.dlParams.fd;
    this.getPgbgUploadResult();
  }
};
</script>
<style lang="scss" scoped>
.dev-o-wbbg__result{
  h4{
    padding: 4px 5px 8px;
  }

  p{
    padding: 8px 5px;
  }

  span{
    padding: 4px 2px;
    margin-top: 2px;
  }

}

.dev-o-wbbg__comment{
  font-weight: normal;
}

.dev-o-wbbg__info{
  line-height: 20px;

  .el-link{
    padding: 2px;
  }
}

.dev-o-wbbg__list{
  line-height: 20px;

  li::before{
    content: "";
    display: block;
    position: absolute;
    width: 6px;
    height: 6px;
    margin-top: 6px;
    margin-left: 2px;
    border-radius: 50%;
    background-color: #bcc8cf;
  }

  &-name{
    margin-left: 16px;
    font-weight: bold;
  }

  div{
    margin: 6px 10px;
  }

  i{
    padding-left: 6px;
    font-weight: bold;
  }

}

</style>
